export const POPUP_MESSAGE = 'POPUP_MESSAGE';
export const SHARE_POPUP = 'SHARE_POPUP';
